<div [formGroup]="primaryAddressForm">
    <div class="form-group">
        <div class="row">
            <div class="col-md-4">
                <label class="boldlbl"><span class="errorMsg">*</span>Street Number:</label>
            </div>
            <div class="col-md-2">
                <input type="text" name="ba_str_nbr" id="ba_str_nbr" formControlName="ba_str_nbr"
                    class="form-control form-control-sm" maxlength="10" />
                <span style="color: red;"
                    *ngIf="primaryAddressForm.controls.ba_str_nbr.invalid && primaryAddressForm.controls.ba_str_nbr.touched">
                    <span *ngIf="primaryAddressForm.controls.ba_str_nbr.errors?.required">Please Enter Business Address
                        Street Number (must be numeric). It is a required field.</span>
                    <span *ngIf="primaryAddressForm.controls.ba_str_nbr.errors?.pattern">Please Correct Business Address
                        Street Number. It must be numeric.</span>
                </span>
            </div>
        </div>
        <div>
            <p>(Example: Enter "250" if business address is 250 N Main St.)
            </p>
        </div>
    </div>
    <div class="form-group">
        <div class="row">
            <div class="col-md-4">
                <label class="boldlbl">Street Number Fraction:</label>
            </div>
            <div class="col-md-2">
                <input type="text" name="ba_str_nbr_frac" id="ba_str_nbr_frac" formControlName="ba_str_nbr_frac"
                    class="form-control form-control-sm" maxlength="5" />
            </div>
        </div>
        <div>
            <p>(Example: Enter "1/2" if business address is 250 1/2 N Main St.)
            </p>
        </div>
    </div>
    <div class="form-group">
        <div class="row">
            <div class="col-md-4">
                <label class="boldlbl">Directional Prefix:</label>
            </div>
            <div class="col-md-2">
                <select id="ba_str_dir_prefix" name="ba_str_dir_prefix" formControlName="ba_str_dir_prefix"
                    class="form-control form-control-sm">
                    <option value=""></option>
                    <option value="N">N</option>
                    <option value="NE">NE</option>
                    <option value="E">E</option>
                    <option value="SE">SE</option>
                    <option value="S">S</option>
                    <option value="SW">SW</option>
                    <option value="W">W</option>
                </select>
            </div>
        </div>
        <div>
            <p>(Example: Select "N" if your business address is 250 N Main St.)
            </p>
        </div>
    </div>
    <div class="form-group">
        <div class="row">
            <div class="col-md-4">
                <label class="boldlbl"><span class="errorMsg">*</span>Street Name:</label>
            </div>
            <div class="col-md-5">
                <input type="text" name="ba_str_nm" id="ba_str_nm" formControlName="ba_str_nm"
                    class="form-control form-control-sm" maxlength="45" />
                <span style="color: red;"
                    *ngIf="primaryAddressForm.controls.ba_str_nm.invalid && primaryAddressForm.controls.ba_str_nm.touched">
                    <span *ngIf="primaryAddressForm.controls.ba_str_nm.errors?.required">Please Enter Business Address
                        Street Name. It is a required field.</span>
                </span>
            </div>
        </div>
        <div>
            <p>(Example: Enter "Main" if your business address is 250 N Main St.)
            </p>
        </div>
    </div>
    <div class="form-group">
        <div class="row">
            <div class="col-md-4">
                <label class="boldlbl">Directional Suffix:</label>
            </div>
            <div class="col-md-2">
                <select id="ba_str_dir_suffix" name="ba_str_dir_suffix" formControlName="ba_str_dir_suffix"
                    class="form-control form-control-sm">
                    <option value=""></option>
                    <option value="N">N</option>
                    <option value="NE">NE</option>
                    <option value="E">E</option>
                    <option value="SE">SE</option>
                    <option value="S">S</option>
                    <option value="SW">SW</option>
                    <option value="W">W</option>
                </select>
            </div>
        </div>
        <div>
            <p>(Example: Select "W" if your business address is 300 Century West Ave.)
            </p>
        </div>
    </div>
    <div class="form-group">
        <div class="row">
            <div class="col-md-4">
                <label class="boldlbl">Street Type:</label>
            </div>
            <div class="col-md-2">
                <select id="ba_str_type" name="ba_str_type" formControlName="ba_str_type"
                    class="form-control form-control-sm">
                    <ng-container *ngFor="let streetType of streetTypeList">
                        <option [value]="streetType.strStreet_Cd">{{streetType.strDescription}}</option>
                    </ng-container>
                </select>
            </div>
        </div>
        <div>
            <p>(Example: Select "STREET" if your business address is 250 N Main St.)
            </p>
        </div>
    </div>
    <div class="form-group">
        <div class="row">
            <div class="col-md-4">
                <label class="boldlbl">Unit Type:</label>
            </div>
            <div class="col-md-4">
                <select id="ba_unit_type" name="ba_unit_type" formControlName="ba_unit_type"
                    class="form-control form-control-sm">
                    <ng-container *ngFor="let unitType of unitTypeList">
                        <option [value]="unitType.strUnit_Cd">{{unitType.strDescription}}</option>
                    </ng-container>
                </select>
            </div>
        </div>
        <div>
            <p class="boldlbl errorMsg">(PO Box is not accepted for the business address)
            </p>
        </div>
    </div>
    <div class="form-group">
        <div class="row">
            <div class="col-md-4">
                <label class="boldlbl">Unit Number:</label>
            </div>
            <div class="col-md-4">
                <input type="text" name="ba_unit_nbr" id="ba_unit_nbr" formControlName="ba_unit_nbr"
                    formControlName="ba_unit_nbr" class="form-control form-control-sm" maxlength="10" />
            </div>
        </div>
        <div>
            <p>(Enter unit number, if applicable)
            </p>
        </div>
    </div>
    <div class="form-group">
        <div class="row">
            <div class="col-md-4">
                <label class="boldlbl"><span class="errorMsg">*</span>City</label>
            </div>
            <div class="col-md-3">
                <input type="text" name="ba_city" id="ba_city" formControlName="ba_city"
                    class="form-control form-control-sm" maxlength="25" />
                <span style="color: red;"
                    *ngIf="primaryAddressForm.controls.ba_city.invalid && primaryAddressForm.controls.ba_city.touched">
                    <span *ngIf="primaryAddressForm.controls.ba_city.errors?.required">Please Enter Business Address
                        City. It is a required field.</span>
                </span>
            </div>
        </div>
        <div>
            <p>(Enter business address city)
            </p>
        </div>
    </div>
    <div class="form-group">
        <div class="row">
            <div class="col-md-4">
                <label class="boldlbl"><span class="errorMsg">*</span>State</label>
            </div>
            <div class="col-md-3">
                <select id="ba_state" name="ba_state" formControlName="ba_state" formControlName="ba_state"
                    class="form-control form-control-sm">
                    <ng-container *ngFor="let state of stateList">
                        <option [value]="state.strState">{{state.strState_Name}}</option>
                    </ng-container>
                </select>
                <span style="color: red;"
                    *ngIf="primaryAddressForm.controls.ba_state.invalid && primaryAddressForm.controls.ba_state.touched">
                    <span *ngIf="primaryAddressForm.controls.ba_state.errors?.required">Select Business Address
                        State</span>
                </span>
            </div>
        </div>
        <div>
            <p>(Select business address State)
            </p>
        </div>
    </div>
    <div class="form-group">
        <div class="row">
            <div class="col-md-4">
                <label class="boldlbl"><span class="errorMsg">*</span>Zip Code:</label>
            </div>
            <div class="col-md-3">
                <input type="text" name="ba_zipcd" id="ba_zipcd" formControlName="ba_zipcd"
                    class="form-control form-control-sm" maxlength="5" />
                <span style="color: red;"
                    *ngIf="primaryAddressForm.controls.ba_zipcd.invalid && primaryAddressForm.controls.ba_zipcd.touched">
                    <span *ngIf="primaryAddressForm.controls.ba_zipcd.errors?.required;else checklenPattern">Please Enter Business Address
                        Zip Code (99999). It is a required field.</span>
                    <ng-template #checklenPattern>
                    	<span *ngIf="primaryAddressForm.controls.ba_zipcd.errors?.pattern;else checkLength">Please Correct Business Address
                        	Zip Code (99999). It must be numeric.</span>
                    	<ng-template #checkLength>
                    		<span *ngIf="primaryAddressForm.controls.ba_zipcd.errors?.minlength">Please Correct Business Address
                        	Zip Code (99999). It must consist of five digits.</span>
                    	</ng-template>
                    </ng-template>
                </span>
            </div>
        </div>
        <div>
            <p>(Enter five digit business zip code)
            </p>
        </div>
    </div>
    <div class="form-group">
        <div class="row">
            <div class="col-md-4">
                <label class="boldlbl">Care Of (C/O):</label>
            </div>
            <div class="col-md-7">
                <input type="text" name="ba_careof" id="ba_careof" formControlName="ba_careof"
                    class="form-control form-control-sm" maxlength="45" />
            </div>
        </div>
    </div>
    <div class="form-group">
        <div class="row">
            <div class="col-md-4">
                <label class="boldlbl"><span class="errorMsg">*</span>Location Type:</label>
            </div>
            <div class="col-md-8">
                <div class="form-check-inline">
                    <input type="radio" class="form-check-input" formControlName="ba_commercial" value="Y" />
                    &nbsp;&nbsp; <label class="form-check-label boldlbl">Commercial Location</label>
                </div>
                <div class="form-check-inline">
                    <input type="radio" class="form-check-input" formControlName="ba_commercial" value="N" />
                    &nbsp;&nbsp; <label class="form-check-label boldlbl">Residence</label>
                </div>
                <p style="color: red;"
                    *ngIf="primaryAddressForm.controls.ba_commercial.invalid && primaryAddressForm.controls.ba_commercial.touched">
                    <span *ngIf="primaryAddressForm.controls.ba_commercial.errors?.required">Select Business Address
                        Location Type - Commercial Location or Residence</span>
                </p>
            </div>
        </div>
    </div>
</div>